import HTTP_GESCOM from '@/api/HTTP_GESCOM';

const URL_BASE = 'commun/Settings/';

export async function getParamAffixe2(key) {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetSettingAsync?key=' + key);
  return response;
}

export async function getAll(type) {
  const queryItems = {
    params: {
      MaxResultCount: 99999,
      Sorting: 'libelle ASC',
    },
  };
  const response = await HTTP_GESCOM.get(type + '/GetAllAsync', queryItems);
  return response;
}

export async function create(type, data) {
  const response = await HTTP_GESCOM.post(type + '/CreateAsync', data);
  return response;
}
